<div class="container-fluid">
  <si-card class="h-100" [heading]="'USERCHARTS.TITLE' | translate">
    <div class="card-body d-flex flex-column" body>
      <div class="p-3 d-flex flex-column gap-3">
        <!-- Metric Selection Panel -->
        <div class="row">
          <!-- Simulation Data Metrics -->
          <div class="col-md-12">
            <si-form-item [label]="'USERCHARTS.SIMULATION_RESULTS' | translate">
              <si-select
                labelledby="simulation-metrics-select"
                multi
                class="form-control"
                [placeholder]="'USERCHARTS.SELECT_METRICS' | translate"
                [options]="metricSelectOptions()"
                [ngModel]="selectedSimulationMetrics()"
                (ngModelChange)="onSimulationMetricsChange($event)"
              />
            </si-form-item>
          </div>
        </div>

        <!-- Plot Type Selection -->
        <div class="d-flex align-items-center gap-3">
          <span class="fw-bold">{{ 'USERCHARTS.PLOT_TYPE' | translate }}:</span>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="plotType"
              id="plotTypePosition"
              value="position"
              [ngModel]="plotType()"
              (ngModelChange)="plotType.set($event)"
            />
            <label class="form-check-label" for="plotTypePosition">{{
              'USERCHARTS.OVER_POSITION' | translate
            }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="plotType"
              id="plotTypeTime"
              value="time"
              [ngModel]="plotType()"
              (ngModelChange)="plotType.set($event)"
            />
            <label class="form-check-label" for="plotTypeTime">{{
              'USERCHARTS.OVER_TIME' | translate
            }}</label>
          </div>
        </div>

        <!-- Scale hint when 3+ distinct units selected -->
        @if (scaleWarning(); as warning) {
          <si-inline-notification class="mt-2" severity="info" [message]="warning" />
        }

        <!-- Combined Chart -->
        @if (combinedChartOptions(); as options) {
          <div class="chart-container w-100 mt-3">
            @for (key of [chartKey()]; track key) {
              <!-- @for trick forces si-chart re-creation when y-axis count changes (ECharts limitation) -->
              <si-chart
                #combinedChart
                class="sichart bg-base-1 plot"
                renderer="svg"
                [options]="options"
                [zoomSlider]="true"
                [zoomInside]="true"
                [cdkContextMenuTriggerFor]="contextMenu"
                (contextmenu)="setActiveChart($event)"
                (siResizeObserver)="combinedChart.resize()"
              />
            }
          </div>
        } @else {
          <si-inline-notification
            class="mt-3"
            severity="info"
            [message]="'USERCHARTS.SELECT_METRIC_INFO' | translate"
          />
        }
      </div>
    </div>
  </si-card>
</div>

<ng-template #contextMenu>
  <si-menu>
    <si-menu-item (click)="downloadChartAsSVG()">Download Chart as SVG</si-menu-item>
  </si-menu>
</ng-template>
